import { YHModal } from '@/components/YHModal'
import { useHomerModal } from './homeModel'
import { Checkbox, message } from 'antd'
import FontIcon from '@/components/YhIcon'
import { IconNameEnum, IconStatusEnum } from '@/types/AppEnums'
import { MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons'
export const NavigationModel = () => {
    const { visible, setVisible, navOptions, setNavOptions,noCheckValues,setNoCheckValues, checkValues, setCheckValues, setUpdate } = useHomerModal()
    const onCancel = () => {
        setVisible(false)
    }
    const onOk = async () => {
        if (checkValues.length < 3) {
            return message.warning('请您最少选择3项')
        }
        let retData = await setUpdate()
        if (retData) {
            onCancel()
        }
        setVisible(false)
    }
    const onDelChange = (checkedValues) => {
        let newData:any=checkValues.filter((item)=>item!==checkedValues)
        let newnoData:any=noCheckValues.concat(checkedValues)
        setCheckValues(newData)
        setNoCheckValues(newnoData)
        if (newData.length >= 3) {
            let newNavOptions = navOptions.map((item) => {
                return {
                    ...item,
                    disabled: newData.indexOf(item) === -1 ? true : false,
                }
            })
            setNavOptions(newNavOptions)
            // message.warning('最多选择9项')
        } else {
            setNavOptions(navOptions.map((item) => ({ ...item, disabled: false })))
        }
    }
    const onAddChange = (checkedValues) => {
        let newnoData:any=noCheckValues.filter((item)=>item!==checkedValues)
        let newData:any=checkValues.concat(checkedValues)

        if (checkValues.length >= 8) {
            // let newNavOptions = navOptions.map((item) => {
            //     return {
            //         ...item,
            //         disabled: newData.indexOf(item) === -1 ? true : false,
            //     }
            // })
            // setNavOptions(newNavOptions)
            return message.warning('最多选择8项')
        } else {
            setCheckValues(newData)
            setNoCheckValues(newnoData)
            setNavOptions(navOptions.map((item) => ({ ...item, disabled: false })))
        }
    }
    return (
        <YHModal visible={visible} onOk={onOk} onCancel={onCancel} title="快捷入口配置" width={796} bodyHeight={550} showFooter={true}>
            <div style={{ marginLeft: '25px', marginTop: '20px' }}>
                <span style={{color:'black',fontSize:'16px',fontWeight:'bolder',lineHeight:' 34px'}}>已选快捷方式<span style={{color:'#9B9EAC',fontSize:'14px'}}>（最多可选择9个）</span></span>
                <div style={{display:'flex',flexDirection:'row',width:'760px',flexWrap:'wrap',alignContent:'flex-start',justifyContent:'flex-start'}}>
                {checkValues?.map((item) =>                
                <div style={{width:'84px',height:'90px',cursor: 'pointer',border: '1px dotted #E8E8E8',display:'flex',flexDirection:'column'}}>
                    <div>
                    <FontIcon type={IconStatusEnum[IconNameEnum[item]]} style={{fontSize: '36px', margin: '12px 0px 5px 24px',color:'#51DF92' }}/>
                    <MinusCircleFilled onClick={()=>onDelChange(item)} style={{fontSize: '16px', cursor: 'pointer',color:'#f97777',float: 'right'}}/>
                    </div>
                    <span style={{textAlign: 'center',fontSize:'15px',lineHeight: '30px',color:'#333333'}}>{IconNameEnum[item]}</span>
                </div>)}
                </div>
            </div>
            <div style={{ marginLeft: '25px', marginTop: '20px' }}>
            <span style={{color:'black',fontSize:'16px',fontWeight:'bolder',lineHeight:' 34px'}}>可选快捷方式</span>
                {/* <Checkbox.Group options={navOptions} defaultValue={checkValues} onChange={onChange} /> */}
                <div style={{display:'flex',flexDirection:'row' ,width:'760px',flexWrap:'wrap',alignContent:'flex-start',justifyContent:'flex-start'}}>
                {noCheckValues?.map((item) =>                
                <div style={{width:'84px',height:'90px',cursor: 'pointer',border: '1px dotted #E8E8E8',display:'flex',flexDirection:'column'}}>
                    <div>
                    <FontIcon type={IconStatusEnum[IconNameEnum[item]]} style={{fontSize: '36px', margin: '12px 0px 5px 24px',color:'#51DF92' }}/>
                    <PlusCircleFilled onClick={()=>onAddChange(item)} style={{fontSize: '16px', cursor: 'pointer',color:'#7edc4b',float: 'right'}}/>
                    </div>
                    <span style={{textAlign: 'center',fontSize:'15px',lineHeight: '30px',color: '#333333'}}>{IconNameEnum[item]}</span>
                </div>)}
                </div>
            </div>
        </YHModal>
    )
}
